export const getSelfRegisterDetails = (state) => state.SelfRegisterDetails;
export const getQuickPermitDetail = (state) =>
  state.SelfRegisterDetails.quickPermitDetail;
export const getQuickPermitSetupDetail = (state) =>
  state.SelfRegisterDetails.quickPermitSetupDetail;
